import { createAction, props } from '@ngrx/store';
import { DiscoveryFlight } from '@fsp-lib/discovery-flights';

// Load Flight Details
export const clearFlightDetails = createAction(
  '[Discovery Flights] Clear Flight Details',
);

export const loadFlightDetails = createAction(
  '[Discovery Flights] Load Flight Details',
  props<{ flightSchoolId: number; flightId: string }>(),
);

export const loadFlightDetailsSuccess = createAction(
  '[Discovery Flights] Load Flight Details Success',
  props<{ flightDetails: DiscoveryFlight }>(),
);

export const loadFlightDetailsFailure = createAction(
  '[Discovery Flights] Load Flight Details Failure',
  props<{ error: string }>(),
);

// Clear Actions
export const clearErrors = createAction('[Discovery Flights] Clear Errors');

export const resetState = createAction('[Discovery Flights] Reset State');
